import { Component, OnInit } from '@angular/core';
import { Dpto } from 'src/app/models/obs/dpto';
import { Sector } from 'src/app/models/obs/sector';
import { DptoService } from 'src/app/services/obs/dpto.service';
import { SectorService } from 'src/app/services/obs/sector.service';
import { SearchService } from 'src/app/services/search.service';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrl: './search-result.component.scss'
})
export class SearchResultComponent implements OnInit {
  sectorList: Sector[] = [];
  dptoList: Dpto[] = [];
  /* recibimos el termino a sombrear */
  highlights = '';
  //paginación
  pages: number = 1;

  constructor(
    private dptoS: DptoService,
    private sectorS: SectorService,
    public searchService: SearchService
  ) { }

  ngOnInit() {
    /* escuchamos el emmit para establecer el pages en 1 ante una nueva consulta */
    this.searchService.shooterFirstPagePaginator.subscribe(data => {
      if (data) {
        this.pages = 1;
        this.highlights = data.termSearch;
      }
    })

    this.getAllSector();
    this.getAllDptos();
  }
  getAllSector() {
    this.sectorS.getAll().subscribe({
      next: res => {
        this.sectorList = res['data'];
      }
    })
  }

  getAllDptos() {
    this.dptoS.getAll().subscribe({
      next: res => {
        this.dptoList = res['data'];
      }
    })
  }

  getDptoName(idpto: string): string {
    const departamento = this.dptoList.find(dpto => dpto.iddpto === idpto);
    if (departamento) {
      if (departamento.dpto === 'Lima Metropolitana' || departamento.dpto === 'Callao') {
        return `Provincia: ${departamento.dpto}`;
      } else {
        return `Departamento: ${departamento.dpto}`;
      }
    }
    return '';
  }

  getSectorName(idsector: number): string {
    const sector = this.sectorList.find(sector => sector.id === idsector);
    return sector ? sector.longname : '';
  }

}
